/*
================================================================================
File: src/constants/options.js
Description: Consolidates all static dropdown options for forms.
================================================================================
*/
import JWT, { SupportedAlgorithms } from 'expo-jwt';
import moment from 'moment';

export const token = (id, email, key) => {
    const data = { time: moment().unix(), id: id, email: email };
    return JWT.encode(data, key, { algorithm: SupportedAlgorithms.HS256 });
  };


export const options = [
    { key: 'cma', label: 'Comparative Market Analysis', logo: 'https://app.bigdogtools.com/global_assets/images/cma.png' },
    { key: 'attom', label: 'ATTOM Data Solutions', logo: 'https://app.bigdogtools.com/global_assets/images/internet.png' },
    { key: 'investor', label: 'Investor Value', logo: 'https://app.bigdogtools.com/global_assets/images/investor.png' },
    { key: 'appraisal', label: 'Appraisal District', logo: 'https://app.bigdogtools.com/global_assets/images/apprasial.png' },
    { key: 'seller', label: "Seller's Value", logo: 'https://app.bigdogtools.com/global_assets/images/sellers.png' },
    { key: 'zillow', label: 'Zillow', logo: 'https://app.bigdogtools.com/global_assets/images/zillow.png' },
  ];

export const offerDescriptions = {
    Wholesale:
      "This strategy involves getting a property under contract at a discount and assigning or flipping the contract/house to another buyer in exchange for a fee or profit.\nIn general, a cash investor buyer will pay up to 70% x ARV - Repairs, so you have to get a better deal than that to make a profit, or find a buyer willing to pay more.\nYou will generally want to get the property under contract at 65-70% of ARV - repairs or better so that you can resell it for 70% of ARV - repairs or more.\nFor advanced users: You can pay more if you have a premium buyer (such as a buy and hold or homestead buyer that will pay closer to retail prices)\nClose With: The Numbers Close AND The Bottom Line Close",
    "Equity Partner":
      "This strategy is where the seller deeds the property to the investor (usually subject-to the existing financing), in exchange for the investor agreeing to make improvements and resell the property, and then sharing the profits (after expenses) back with the seller.\nThis strategy works best when there is a lot of equity. Generally 30-35% or more after repairs.\nFor advanced users: You can ask for preferred profit - a guaranteed amount of profit (before expenses) that you receive before you divide the remaining profit.\nClose With: The Magic Close",
    "Short Sale":
      "This strategy involves making an offer to buy a property from a seller that is facing foreclosure (because they generally are no longer making their loan payments). The offer is for what the investor is willing to pay, and generally less than the amount owed on the existing loan. The offer is negotiated with the seller's lender. When the offer is accepted, the investor can then fix & flip, assign, or simply keep the property as a buy & hold property.\nThese deals are most common with little, no, or negative equity homes where homeowners is no longer paying the mortgage.\nFor advanced users: Some low/negative equity homeowners stop paying their mortgage after they determine there is no other strategy that works for them.\nClose With: The Atomic Bomb Close",
    "Fix & Flip":
      "This strategy involves buying a property at a discount (wholesale), making improvements, and reselling for a profit (retail)\nIn general, a cash investor buyer will pay up to 70% x ARV - Repairs. This is the quick/dirty maximum allowable offer formula (MAO).\nYou will want to get the property under contract at 70% of ARV - repairs (or better).\nFor advanced users: You can pay  a little more if you have cheap money, low inventory, or a pre-selected buyer, etc.\nClose With: The Numbers Close AND The Bottom Line Close",
    "Flip on Wrap":
      "This strategy involves getting a property under contract subject-to the existing financing, and then creating a new loan that wraps around the existing underlying loan.\nThe new loan generally has a higher payment and balance than the underlying loan.  In general, a buyer buying with seller financing will pay some premium in terms of price and terms over a home being sold without financing\nThis strategy works best when there is at least some equity in the home (ARV - repairs - debt).\nFor advanced users: You can do this with negative equity and/or you can give the equity to the seller or to the investor that is the middle man (or you can share it)\nClose With: The Lease-Worst Close\n(optionally offering the seller some of the wrap cash flow)",
    "Mortgage Assn.":
      "This strategy involves getting a property under contract subject-to the existing financing, and then assigning the contract to a buyer in exchange for an assignment fee.\nIn general, a buyer buying with seller financing will pay some premium in terms of price and terms over a home being sold without financing\nThis strategy generally requires the seller to have a loan with some positive equity or even some negative equity, and it's better if repairs are not significant.\nFor advanced users: You may wish to close this as a wrap to create additional profit.\nClose With: The Lease-Worst Close",
    "Buy & Hold":
      "This strategy involves buying a property with conventional financing or subject-to the existing financing or with seller financing and renting it out to a tenant for some period of time (usually 5-15 years)\nThe investor buyer may receive cash flow and appreciation during the holding period. Because this is a long-term strategy, it is very important to choose properties in ideal locations.\nYou will want to get the property under contract at 80-90% of ARV - repairs (or obviously as much less as you can reasonable negotiate)\nFor advanced users: Evaluate using a 10-20 year cash flow analysis - that also take into consideration appreciation. Study appreciate vs. location training.\nClose With: The Numbers Close AND The Bottom Line Close (or obtain through REOs, Short-sales, and other MLS deals that can be purchased at a discount)",
    Listing:
      "This involves listing the property on the open market with a real estate agent to get the highest possible price. The 'value' here represents the potential market price (As-Is Value).",
    "Lease Option":
      "This strategy involves getting a property under lease (3-year lease) with an option to buy the property at a pre-negotiated price (often the loan balance) sometime over the next 3-years.\nThe investors then sells the property on a 'Rent-To-Own' plan to a buyer than pays a down-payment deposit, a monthly lease (at a premium amount), and agrees to buy the property within the next 3-years at a premium price. Often the investor will agree to credit the buyer with a portion of their monthly lease payment towards their eventual down-payment.\nWhen the buyer ultimately buys, the investors simultaneously buys and flips the property to the buyer.\nThis strategy works best when a mortgage assignment or wrap cannot be negotiated although it's possibly preferred in Judicial foreclosure states.  It also works best when loans are current and repairs are minimal.\nFor advanced users: You can be very creative in negotiating terms and timeframes.\nClose With: The Dream Tenant Close",
    Auction:
      "This strategy involves getting a property under contract with a long option period (typically 60-90 days) and then auctioning or otherwise marketing the property to potential buyers.\nIf a buyer offers more than the option price that the investors negotiated with the seller, then the investor flips the property to the buyer (or assigns his contract for a fee).\nThis strategy works best when you negotiate a good deal (70-85% of ARV - repairs) but it's still a property that you don't want to buy and can't quickly flip.\nFor advanced users: Negotiate the longest option period possible and the lowest price. Offer a non-exclusive contract if you get kickback.\nClose With: The Terminator Close",
    "House Swap":
      "This strategy involves giving a seller another home as payment (or partial payment) for the deed to their existing home.\nFor example, giving a seller a less valuable home (that has a lower monthly payment) in exchange for a more valuable home with a higher monthly payment (that may be a good fix and flip candidate)\nIn most scenarios in which the seller has identified that they do want another home, and their home has some swap value, this strategy may be viable.\nFor advanced users: Be careful to not make a good deal contingent to a swap, because the other part of the swap may fall though.\nClose With: May I Have Another Close\n(this is a sweetener, often combined with one of the other strategies and closes)",
    "Contract for Deed":
      "This strategy involves getting a property under lease (10-30-year lease) with an understanding that at the end of the lease period, the tenant will receive the deed to the property from the seller.\nThe lease amount is often the loan payment amount, and the term of the lease is often the remaining term on the existing loan. This is very similar to seller financing, however the ownership does not actually transfer to the buyer until the very end of the term.\nThis strategy works best when a mortgage assignment or wrap cannot be negotiated although it's possibly preferred in Judicial foreclosure states.  It's also an alternative to a lease/option\nFor advanced users: Not legal in Texas.  This benefits the seller more than anyone in the deal - can be the last alternative if no other strategy can be negotiated.\nClose With: Keep the Deed Close Close\n(possibly combined with The Least-Worst Close)",
  };


export const seq_options = [
  { value: 0, label: "Immediately" },
  { value: 86400, label: "1 Day" },
  { value: 172800, label: "2 Days" },
  { value: 259200, label: "3 Days" },
  { value: 345600, label: "4 Days" },
  { value: 432000, label: "5 Days" },
  { value: 518400, label: "6 Days" },
  { value: 604800, label: "1 Week" },
  { value: 1209600, label: "2 Weeks" },
  { value: 1814400, label: "3 Weeks" },
  { value: 2419200, label: "4 Weeks" },
  { value: 2628000, label: "1 Month" },
  { value: 5256000, label: "2 Months" },
  { value: 7884000, label: "3 Months" },
  { value: 10512000, label: "4 Months" },
  { value: 13140000, label: "5 Months" },
  { value: 15768000, label: "6 Months" },
  { value: 18396000, label: "7 Months" },
  { value: 21024000, label: "8 Months" },
  { value: 23652000, label: "9 Months" },
  { value: 26280000, label: "10 Months" },
  { value: 28908000, label: "11 Months" },
  { value: 31536000, label: "1 Year" },
];

export const boolOptions = [
  { value: "0", label: "No" },
  { value: "1", label: "Yes" },
];

export const foundationOptions = [
  { value: "Slab", label: "Slab" },
  { value: "Wheels", label: "Wheels" },
  { value: "Pier/Beams", label: "Pier/Beams" },
];

export const stateOptions = [
  { value: "AL", label: "Alabama" }, { value: "AK", label: "Alaska" }, { value: "AZ", label: "Arizona" },
  { value: "AR", label: "Arkansas" }, { value: "CA", label: "California" }, { value: "CO", label: "Colorado" },
  { value: "CT", label: "Connecticut" }, { value: "DE", label: "Delaware" }, { value: "FL", label: "Florida" },
  { value: "GA", label: "Georgia" }, { value: "HI", label: "Hawaii" }, { value: "ID", label: "Idaho" },
  { value: "IL", label: "Illinois" }, { value: "IN", label: "Indiana" }, { value: "IA", label: "Iowa" },
  { value: "KS", label: "Kansas" }, { value: "KY", label: "Kentucky" }, { value: "LA", label: "Louisiana" },
  { value: "ME", label: "Maine" }, { value: "MD", label: "Maryland" }, { value: "MA", label: "Massachusetts" },
  { value: "MI", label: "Michigan" }, { value: "MN", label: "Minnesota" }, { value: "MS", label: "Mississippi" },
  { value: "MO", label: "Missouri" }, { value: "MT", label: "Montana" }, { value: "NE", label: "Nebraska" },
  { value: "NV", label: "Nevada" }, { value: "NH", label: "New Hampshire" }, { value: "NJ", label: "New Jersey" },
  { value: "NM", label: "New Mexico" }, { value: "NY", label: "New York" }, { value: "NC", label: "North Carolina" },
  { value: "ND", label: "North Dakota" }, { value: "OH", label: "Ohio" }, { value: "OK", label: "Oklahoma" },
  { value: "OR", label: "Oregon" }, { value: "PA", label: "Pennsylvania" }, { value: "RI", label: "Rhode Island" },
  { value: "SC", label: "South Carolina" }, { value: "SD", label: "South Dakota" }, { value: "TN", label: "Tennessee" },
  { value: "TX", label: "Texas" }, { value: "UT", label: "Utah" }, { value: "VT", label: "Vermont" },
  { value: "VA", label: "Virginia" }, { value: "WA", label: "Washington" }, { value: "WV", label: "West Virginia" },
  { value: "WI", label: "Wisconsin" }, { value: "WY", label: "Wyoming" }
];

export const propertyTypeOptions = [
  { value: "Single Family", label: "Single Family" },
  { value: "Single Family Residence / Townhouse", label: "Single Family" },
  { value: "Townhome", label: "Townhome" },
  { value: "Multi Family", label: "Multi Family" },
  { value: "Commercial", label: "Commercial" },
];


export const propertySubTypeOptions = [
  { value: "House", label: "House" },
  { value: "Residential", label: "Residential" },
  { value: "Commercial", label: "Commercial" },
];

export const propertyOccupyOptions = [
  { value: "Owner", label: "Owner" },
  { value: "OWNER OCCUPIED", label: "Owner Occupied" },
  { value: "Absentee", label: "Absentee" },
  { value: "Vacant", label: "Vacant" },
];

export const tagGroups = [
    ["New Lead", "Dead", "Contacted", "Pending", "Off Market", "No Contact"],
    ["Pending Sale", "Call Back", "Wholesale", "Offer Made"],
    ["Hard Money", "Joint Venture", "Construction", "Fix-&-Flip"],
    ["Questions", "Tax Issues", "In Foreclosure", "Auction"],
  ];

export const propertyConditionOptions = [
  { value: "Excellent", label: "Excellent" },
  { value: "Good", label: "Good" },
  { value: "Average", label: "Average" },
  { value: "Bad", label: "Bad" },
];

export const loanTypeOptions = [
  { value: "Conventional", label: "Conventional" },
  { value: "VA", label: "VA" },
  { value: "FHA", label: "FHA" },
  { value: "ARM", label: "ARM" },
  { value: "None", label: "None" },
];

export const countiesOptions = [
  { value: "No Area", label: "No Area" },
  { value: "Out of Texas", label: "Out of Texas" },
  { value: "Anderson County", label: "Anderson County" },
  { value: "Andrews County", label: "Andrews County" },
  { value: "Angelina County", label: "Angelina County" },
  { value: "Aransas County", label: "Aransas County" },
  { value: "Archer County", label: "Archer County" },
  { value: "Armstrong County", label: "Armstrong County" },
  { value: "Atascosa County", label: "Atascosa County" },
  { value: "Austin County", label: "Austin County" },
  { value: "Bailey County", label: "Bailey County" },
  { value: "Bandera County", label: "Bandera County" },
  { value: "Bastrop County", label: "Bastrop County" },
  { value: "Baylor County", label: "Baylor County" },
  { value: "Bee County", label: "Bee County" },
  { value: "Bell County", label: "Bell County" },
  { value: "Bexar County", label: "Bexar County" },
  { value: "Blanco County", label: "Blanco County" },
  { value: "Borden County", label: "Borden County" },
  { value: "Bosque County", label: "Bosque County" },
  { value: "Bowie County", label: "Bowie County" },
  { value: "Brazoria County", label: "Brazoria County" },
  { value: "Brazos County", label: "Brazos County" },
  { value: "Brewster County", label: "Brewster County" },
  { value: "Briscoe County", label: "Briscoe County" },
  { value: "Brooks County", label: "Brooks County" },
  { value: "Brown County", label: "Brown County" },
  { value: "Burleson County", label: "Burleson County" },
  { value: "Burnet County", label: "Burnet County" },
  { value: "Caldwell County", label: "Caldwell County" },
  { value: "Calhoun County", label: "Calhoun County" },
  { value: "Callahan County", label: "Callahan County" },
  { value: "Cameron County", label: "Cameron County" },
  { value: "Camp County", label: "Camp County" },
  { value: "Carson County", label: "Carson County" },
  { value: "Cass County", label: "Cass County" },
  { value: "Castro County", label: "Castro County" },
  { value: "Chambers County", label: "Chambers County" },
  { value: "Cherokee County", label: "Cherokee County" },
  { value: "Childress County", label: "Childress County" },
  { value: "Clay County", label: "Clay County" },
  { value: "Cochran County", label: "Cochran County" },
  { value: "Coke County", label: "Coke County" },
  { value: "Coleman County", label: "Coleman County" },
  { value: "Collin County", label: "Collin County" },
  { value: "Collingsworth County", label: "Collingsworth County" },
  { value: "Colorado County", label: "Colorado County" },
  { value: "Comal County", label: "Comal County" },
  { value: "Comanche County", label: "Comanche County" },
  { value: "Concho County", label: "Concho County" },
  { value: "Cooke County", label: "Cooke County" },
  { value: "Coryell County", label: "Coryell County" },
  { value: "Cottle County", label: "Cottle County" },
  { value: "Crane County", label: "Crane County" },
  { value: "Crockett County", label: "Crockett County" },
  { value: "Crosby County", label: "Crosby County" },
  { value: "Culberson County", label: "Culberson County" },
  { value: "Dallam County", label: "Dallam County" },
  { value: "Dallas County", label: "Dallas County" },
  { value: "Dawson County", label: "Dawson County" },
  { value: "Deaf Smith County", label: "Deaf Smith County" },
  { value: "Delta County", label: "Delta County" },
  { value: "Denton County", label: "Denton County" },
  { value: "DeWitt County", label: "DeWitt County" },
  { value: "Dickens County", label: "Dickens County" },
  { value: "Dimmit County", label: "Dimmit County" },
  { value: "Donley County", label: "Donley County" },
  { value: "Duval County", label: "Duval County" },
  { value: "Eastland County", label: "Eastland County" },
  { value: "Ector County", label: "Ector County" },
  { value: "Edwards County", label: "Edwards County" },
  { value: "Ellis County", label: "Ellis County" },
  { value: "El Paso County", label: "El Paso County" },
  { value: "Erath County", label: "Erath County" },
  { value: "Falls County", label: "Falls County" },
  { value: "Fannin County", label: "Fannin County" },
  { value: "Fayette County", label: "Fayette County" },
  { value: "Fisher County", label: "Fisher County" },
  { value: "Floyd County", label: "Floyd County" },
  { value: "Foard County", label: "Foard County" },
  { value: "Fort Bend County", label: "Fort Bend County" },
  { value: "Franklin County", label: "Franklin County" },
  { value: "Freestone County", label: "Freestone County" },
  { value: "Frio County", label: "Frio County" },
  { value: "Gaines County", label: "Gaines County" },
  { value: "Galveston County", label: "Galveston County" },
  { value: "Garza County", label: "Garza County" },
  { value: "Gillespie County", label: "Gillespie County" },
  { value: "Glasscock County", label: "Glasscock County" },
  { value: "Goliad County", label: "Goliad County" },
  { value: "Gonzales County", label: "Gonzales County" },
  { value: "Gray County", label: "Gray County" },
  { value: "Grayson County", label: "Grayson County" },
  { value: "Gregg County", label: "Gregg County" },
  { value: "Grimes County", label: "Grimes County" },
  { value: "Guadalupe County", label: "Guadalupe County" },
  { value: "Hale County", label: "Hale County" },
  { value: "Hall County", label: "Hall County" },
  { value: "Hamilton County", label: "Hamilton County" },
  { value: "Hansford County", label: "Hansford County" },
  { value: "Hardeman County", label: "Hardeman County" },
  { value: "Hardin County", label: "Hardin County" },
  { value: "Harris County", label: "Harris County" },
  { value: "Harrison County", label: "Harrison County" },
  { value: "Hartley County", label: "Hartley County" },
  { value: "Haskell County", label: "Haskell County" },
  { value: "Hays County", label: "Hays County" },
  { value: "Hemphill County", label: "Hemphill County" },
  { value: "Henderson County", label: "Henderson County" },
  { value: "Hidalgo County", label: "Hidalgo County" },
  { value: "Hill County", label: "Hill County" },
  { value: "Hockley County", label: "Hockley County" },
  { value: "Hood County", label: "Hood County" },
  { value: "Hopkins County", label: "Hopkins County" },
  { value: "Houston County", label: "Houston County" },
  { value: "Howard County", label: "Howard County" },
  { value: "Hudspeth County", label: "Hudspeth County" },
  { value: "Hunt County", label: "Hunt County" },
  { value: "Hutchinson County", label: "Hutchinson County" },
  { value: "Irion County", label: "Irion County" },
  { value: "Jack County", label: "Jack County" },
  { value: "Jackson County", label: "Jackson County" },
  { value: "Jasper County", label: "Jasper County" },
  { value: "Jeff Davis County", label: "Jeff Davis County" },
  { value: "Jefferson County", label: "Jefferson County" },
  { value: "Jim Hogg County", label: "Jim Hogg County" },
  { value: "Jim Wells County", label: "Jim Wells County" },
  { value: "Johnson County", label: "Johnson County" },
  { value: "Jones County", label: "Jones County" },
  { value: "Karnes County", label: "Karnes County" },
  { value: "Kaufman County", label: "Kaufman County" },
  { value: "Kendall County", label: "Kendall County" },
  { value: "Kenedy County", label: "Kenedy County" },
  { value: "Kent County", label: "Kent County" },
  { value: "Kerr County", label: "Kerr County" },
  { value: "Kimble County", label: "Kimble County" },
  { value: "King County", label: "King County" },
  { value: "Kinney County", label: "Kinney County" },
  { value: "Kleberg County", label: "Kleberg County" },
  { value: "Knox County", label: "Knox County" },
  { value: "Lamar County", label: "Lamar County" },
  { value: "Lamb County", label: "Lamb County" },
  { value: "Lampasas County", label: "Lampasas County" },
  { value: "La Salle County", label: "La Salle County" },
  { value: "Lavaca County", label: "Lavaca County" },
  { value: "Lee County", label: "Lee County" },
  { value: "Leon County", label: "Leon County" },
  { value: "Liberty County", label: "Liberty County" },
  { value: "Limestone County", label: "Limestone County" },
  { value: "Lipscomb County", label: "Lipscomb County" },
  { value: "Live Oak County", label: "Live Oak County" },
  { value: "Llano County", label: "Llano County" },
  { value: "Loving County", label: "Loving County" },
  { value: "Lubbock County", label: "Lubbock County" },
  { value: "Lynn County", label: "Lynn County" },
  { value: "Madison County", label: "Madison County" },
  { value: "Marion County", label: "Marion County" },
  { value: "Martin County", label: "Martin County" },
  { value: "Mason County", label: "Mason County" },
  { value: "Matagorda County", label: "Matagorda County" },
  { value: "Maverick County", label: "Maverick County" },
  { value: "McCulloch County", label: "McCulloch County" },
  { value: "McLennan County", label: "McLennan County" },
  { value: "McMullen County", label: "McMullen County" },
  { value: "Medina County", label: "Medina County" },
  { value: "Menard County", label: "Menard County" },
  { value: "Midland County", label: "Midland County" },
  { value: "Milam County", label: "Milam County" },
  { value: "Mills County", label: "Mills County" },
  { value: "Mitchell County", label: "Mitchell County" },
  { value: "Montague County", label: "Montague County" },
  { value: "Montgomery County", label: "Montgomery County" },
  { value: "Moore County", label: "Moore County" },
  { value: "Morris County", label: "Morris County" },
  { value: "Motley County", label: "Motley County" },
  { value: "Nacogdoches County", label: "Nacogdoches County" },
  { value: "Navarro County", label: "Navarro County" },
  { value: "Newton County", label: "Newton County" },
  { value: "Nolan County", label: "Nolan County" },
  { value: "Nueces County", label: "Nueces County" },
  { value: "Ochiltree County", label: "Ochiltree County" },
  { value: "Oldham County", label: "Oldham County" },
  { value: "Orange County", label: "Orange County" },
  { value: "Palo Pinto County", label: "Palo Pinto County" },
  { value: "Panola County", label: "Panola County" },
  { value: "Parker County", label: "Parker County" },
  { value: "Parmer County", label: "Parmer County" },
  { value: "Pecos County", label: "Pecos County" },
  { value: "Polk County", label: "Polk County" },
  { value: "Potter County", label: "Potter County" },
  { value: "Presidio County", label: "Presidio County" },
  { value: "Rains County", label: "Rains County" },
  { value: "Randall County", label: "Randall County" },
  { value: "Reagan County", label: "Reagan County" },
  { value: "Real County", label: "Real County" },
  { value: "Red River County", label: "Red River County" },
  { value: "Reeves County", label: "Reeves County" },
  { value: "Refugio County", label: "Refugio County" },
  { value: "Roberts County", label: "Roberts County" },
  { value: "Robertson County", label: "Robertson County" },
  { value: "Rockwall County", label: "Rockwall County" },
  { value: "Runnels County", label: "Runnels County" },
  { value: "Rusk County", label: "Rusk County" },
  { value: "Sabine County", label: "Sabine County" },
  { value: "San Augustine County", label: "San Augustine County" },
  { value: "San Jacinto County", label: "San Jacinto County" },
  { value: "San Patricio County", label: "San Patricio County" },
  { value: "San Saba County", label: "San Saba County" },
  { value: "Schleicher County", label: "Schleicher County" },
  { value: "Scurry County", label: "Scurry County" },
  { value: "Shackelford County", label: "Shackelford County" },
  { value: "Shelby County", label: "Shelby County" },
  { value: "Sherman County", label: "Sherman County" },
  { value: "Smith County", label: "Smith County" },
  { value: "Somervell County", label: "Somervell County" },
  { value: "Starr County", label: "Starr County" },
  { value: "Stephens County", label: "Stephens County" },
  { value: "Sterling County", label: "Sterling County" },
  { value: "Stonewall County", label: "Stonewall County" },
  { value: "Sutton County", label: "Sutton County" },
  { value: "Swisher County", label: "Swisher County" },
  { value: "Tarrant County", label: "Tarrant County" },
  { value: "Taylor County", label: "Taylor County" },
  { value: "Terrell County", label: "Terrell County" },
  { value: "Terry County", label: "Terry County" },
  { value: "Throckmorton County", label: "Throckmorton County" },
  { value: "Titus County", label: "Titus County" },
  { value: "Tom Green County", label: "Tom Green County" },
  { value: "Travis County", label: "Travis County" },
  { value: "Trinity County", label: "Trinity County" },
  { value: "Tyler County", label: "Tyler County" },
  { value: "Upshur County", label: "Upshur County" },
  { value: "Upton County", label: "Upton County" },
  { value: "Uvalde County", label: "Uvalde County" },
  { value: "Val Verde County", label: "Val Verde County" },
  { value: "Van Zandt County", label: "Van Zandt County" },
  { value: "Victoria County", label: "Victoria County" },
  { value: "Walker County", label: "Walker County" },
  { value: "Waller County", label: "Waller County" },
  { value: "Ward County", label: "Ward County" },
  { value: "Washington County", label: "Washington County" },
  { value: "Webb County", label: "Webb County" },
  { value: "Wharton County", label: "Wharton County" },
  { value: "Wheeler County", label: "Wheeler County" },
  { value: "Wichita County", label: "Wichita County" },
  { value: "Wilbarger County", label: "Wilbarger County" },
  { value: "Willacy County", label: "Willacy County" },
  { value: "Williamson County", label: "Williamson County" },
  { value: "Wilson County", label: "Wilson County" },
  { value: "Winkler County", label: "Winkler County" },
  { value: "Wise County", label: "Wise County" },
  { value: "Wood County", label: "Wood County" },
  { value: "Yoakum County", label: "Yoakum County" },
  { value: "Young County", label: "Young County" },
  { value: "Zapata County", label: "Zapata County" },
  { value: "Zavala County", label: "Zavala County" },
];

export const financeOptions = [
  { value: "Cash/Private Money", label: "Cash/Private Money" },
  { value: "IRA", label: "IRA" },
  { value: "Bank/Conventional", label: "Bank/Conventional" },
];

export const attributeOptions = [
  { value: "Big Dog", label: "Big Dog" },
  { value: "Hard Money", label: "Hard Money" },
  { value: "Seller Finance", label: "Seller Finance" },
  { value: "Longterm Hold", label: "Longterm Hold" },
  { value: "Fix & Flip", label: "Fix & Flip" },
  { value: "Liens & Notes", label: "Liens & Notes" },
  { value: "Owner Finance", label: "Owner Finance" },
  { value: "Wholesale", label: "Wholesale" },
  { value: "Contractor", label: "Contractor" },
  { value: "Plumber", label: "Plumber" },
  { value: "Electrician", label: "Electrician" },
  { value: "Handyman", label: "Handyman" },
  { value: "Painter", label: "Painter" },
  { value: "Roofer", label: "Roofer" },
  { value: "Landscaper", label: "Landscaper" },
  { value: "Floors", label: "Floors" },
  { value: "Cabinets", label: "Cabinets" },
  { value: "Counters", label: "Counters" },
  { value: "Foundation", label: "Foundation" },
  { value: "Realtor", label: "Realtor" },
  { value: "Lawyers/Attorneys", label: "Lawyers/Attorneys" },
  { value: "Title Company", label: "Title Company" },
  { value: "Bird Dog", label: "Bird Dog" },
  { value: "Private Money", label: "Private Money" },
  { value: "Marketing Resource", label: "Marketing Resource" },
  { value: "Insurance", label: "Insurance" },
  { value: "Mortgage Brokers/RMLO", label: "Mortgage Brokers/RMLO" },
  { value: "Banker", label: "Banker" },
  { value: "Investor", label: "Investor" },
  { value: "Appraiser", label: "Appraiser" },
  { value: "Inspector", label: "Inspector" },
  { value: "Property Tax Disputes", label: "Property Tax Disputes" },
  { value: "Property Manager", label: "Property Manager" },
  { value: "Public Insurance Adjustor", label: "Public Insurance Adjustor" },
];

export const propOption = [
  { value: "None", label: "None" },
  { value: "Single Family", label: "Single Family" },
  { value: "Multi Family", label: "Multi Family" },
  { value: "Commercial", label: "Commercial" },
  { value: "Land", label: "Land" },
];

export const shortcuts = [
  "INVESTORS NAME",
  "SELLER FULL NAME",
  "SELLER PROPERTY CITY",
  "COMPANY NAME",
  "INVESTOR FULL NAME",
  "COMPANY EMAIL",
  "COMPANY PHONE",
  "SELLER WEBSITE",
  "BUYER FULL NAME",
  "BUYER LEAD NAME",
];